import { ISelectType } from "@4uhub/lib4uhub";
import { GlobalAxios } from "../axios/axios-config";

const TICKET_GENERAL_MACRO_ROUTE =
  process.env.REACT_APP_AUTOMATIONS + "/api/v1/TemplateGeneralMacro";

export const listTemplateGeneralMacros = (params?: any) => {
  return GlobalAxios.get<ISelectType[]>(`${TICKET_GENERAL_MACRO_ROUTE}/list`, {
    params: params,
  });
};
